import styled from "styled-components";
import { BLACK, GRAYSCALE_500, NEUTRAL_100 } from "../../styles/colors";
import { INTER } from "../../styles/fonts";

// Bottom sheet components
export const BottomSheetContent = (styled.div`
  padding: 0px 0px 24px 0px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const RedemptionCard = (styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: 1px solid ${NEUTRAL_100};
  padding: 18px 16px;
  border-radius: 12px;
  box-shadow: 0px 0px 8px 0px ${NEUTRAL_100};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const RedemptionRow = (styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const Divider = (styled.div`
  height: 1px;
  background-color: ${NEUTRAL_100};
  width: 100%;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const LabelText = (styled.span`
  color: ${GRAYSCALE_500};
  font-family: ${INTER.semiBold};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const ValueText = (styled.span`
  color: ${BLACK};
  font-family: ${INTER.regular};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const BoldValueText = (styled(ValueText)`
  font-family: ${INTER.bold};
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any

export const AlertContainer = (styled.div`
  display: flex;
  width: 100%;
  margin-top: 8px;
`) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
